import { render, staticRenderFns } from "./TileAction.vue?vue&type=template&id=850baf9a&scoped=true&"
import script from "./TileAction.vue?vue&type=script&lang=js&"
export * from "./TileAction.vue?vue&type=script&lang=js&"
import style0 from "./TileAction.vue?vue&type=style&index=0&id=850baf9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850baf9a",
  null
  
)

export default component.exports